import { Instance } from 'mobx-state-tree';
import { RouteStagedEditDiscardedDtoModelBase } from './RouteStagedEditDiscardedDtoModel.base';

/* The TypeScript type of an instance of RouteStagedEditDiscardedDtoModel */
export interface RouteStagedEditDiscardedDtoModelType extends Instance<typeof RouteStagedEditDiscardedDtoModel.Type> {}

/* A graphql query fragment builders for RouteStagedEditDiscardedDtoModel */
export { selectFromRouteStagedEditDiscardedDto, routeStagedEditDiscardedDtoModelPrimitives, RouteStagedEditDiscardedDtoModelSelector } from './RouteStagedEditDiscardedDtoModel.base';

/**
 * RouteStagedEditDiscardedDtoModel
 *
 * Route staged edit discarded event
 */
export const RouteStagedEditDiscardedDtoModel = RouteStagedEditDiscardedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
